export const formatPromotionsForEventStream = promotions =>
  promotions
    .map(({ promotion, validFor }) =>
      validFor.map(formatPromotionForEventStream.bind(undefined, promotion))
    )
    .reduce((promos, promo) => promos.concat(promo));

export const formatPromotionForEventStream = (promotion, entity) => ({
  id: promotion.id,
  ownerId: promotion.ownerId,
  categories: promotion.categories,
  entity: {
    id: entity.id,
    name: entity.name,
    type: entity.__typename,
    parentId: entity.parent && entity.parent.id,
  },
});
